import { c as _c } from "react/compiler-runtime";
import { locale } from "@locale";
import classNames from 'classnames';
import getThemeStyles from "src/lib/styling/getThemeStyles";
import styles from './ProgramError.module.css';

//#region [Props]
type ProgramErrorProps = {
  /** refetches the failed queries (from QueryErrorBoundary) */
  onRetry: () => void;
  className?: string;
};
//#endregion

//#region [Component]
export default function ProgramError(t0) {
  const $ = _c(10);
  const {
    onRetry,
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] !== className) {
    const themeStyles = getThemeStyles(styles);
    t1 = "alert";
    t2 = classNames(styles.ProgramError, className, themeStyles);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className={styles.Message}>{locale.program.loadError.message}</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onRetry) {
    t4 = <button type="button" className={styles.RetryButton} onClick={onRetry}>{locale.program.loadError.retry}</button>;
    $[4] = onRetry;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
    t5 = <div role={t1} className={t2}>{t3}{t4}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
//#endregion